import { Box } from "@mui/material";
import warningAlertIcon from "Assets/Icons/warning-alert.svg";

export default function SecurityAlertMessage() {
  return (
    <Box
      role="alert"
      sx={{
        display: "flex",
        flexDirection: "row",
        borderRadius: "var(--spacing-md)",
        background: "var(--color-surface-alerts-status-warn-tint)",
      }}
    >
      <Box
        role="alert"
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          padding: "var(--spacing-md)",
        }}
      >
        <Box>
          <img
            width={22}
            height={22}
            alt="Security Alert"
            src={warningAlertIcon}
          />
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: "var(--spacing-xs)",
          flexDirection: "column",
          padding: "var(--spacing-md)",
        }}
      >
        <Box
          sx={{
            color: "var(--color-text-primary)",
            fontFamily: "var(--body-font-family)",
            fontSize: "var(--body-size)",
            fontWeight: 700,
          }}
        >
          Security Alert
        </Box>
        <Box
          sx={{
            color: "var(--color-text-secondary)",
            fontFamily: "var(--caption-font-family)",
            fontSize: "var(--caption-size-medium)",
            fontWeight: 400,
          }}
        >
          Pavilion Payment will never call and ask you for this code. Please do
          not share it.
        </Box>
      </Box>
    </Box>
  );
}
